import { createBrowserRouter } from "react-router-dom";
import AdminProtectedRoute from "./components/AdminProtectedRoute";
import DashboardSection from "./sections/Dashboard";
import { AdminDashboard } from "./AdminDashboard";
import Users from "./sections/Users";
import PostsSection from "./sections/PostsSection";
import GroupsSection from "./sections/Groups";
import Reports from "./sections/Reports.";
import PublicRoute from "./components/PublicRoute";
import { AdminLogin } from "./pages/Login";
import Pages from "./sections/Pages";
import Campaigns from "./sections/Campaigns";
import MarketplaceReports from "./pages/MarketplaceReports";
import MarketplaceCategories from "./pages/MarketplaceCategories";
import MarketplaceListings from "./pages/MarketplaceListings";
import MarketplaceOffers from "./pages/MarketplaceOffers";
import MarketplaceTransactions from "./pages/MarketplaceTransactions";
import MarketplaceReviews from "./pages/MarketplaceReviews";
import SellerSuspensions from "./sections/SellerSuspensions";
import {
    AnalyticsOverview,
    AnalyticsOffers,
    AnalyticsReviews,
    AnalyticsCategories,
    AnalyticsTopListings,
    AnalyticsSystemHealth,
} from "./pages/analytics";

export const router = createBrowserRouter([
    {
        path: "/",
        element: <AdminProtectedRoute />,
        children: [
            {
                path: "/",
                element: <AdminDashboard children={<DashboardSection />} />,
                index: true
            },
            {
                path: 'userss',
                element: <Users />
            },
            {
                path: "/users",
                element: <AdminDashboard children={<Users />} />,
            },
            {
                path: "/posts",
                element: <AdminDashboard children={<PostsSection />} />,
            },
            {
                path: "/groups",
                element: <AdminDashboard children={<GroupsSection />} />,
            },
            {
                path: "/pages",
                element: <AdminDashboard children={<Pages />} />,
            },
            {
                path: "/reports",
                element: <AdminDashboard children={<Reports />} />,
            },
            {
                path: "/campaigns",
                element: <AdminDashboard children={<Campaigns />} />,
            },
            {
                path: "/marketplace/reports",
                element: <AdminDashboard children={<MarketplaceReports />} />,
            },
            {
                path: "/marketplace/categories",
                element: <AdminDashboard children={<MarketplaceCategories />} />,
            },
            {
                path: "/marketplace/listings",
                element: <AdminDashboard children={<MarketplaceListings />} />,
            },
            {
                path: "/marketplace/offers",
                element: <AdminDashboard children={<MarketplaceOffers />} />,
            },
            {
                path: "/marketplace/transactions",
                element: <AdminDashboard children={<MarketplaceTransactions />} />,
            },
            {
                path: "/marketplace/reviews",
                element: <AdminDashboard children={<MarketplaceReviews />} />,
            },
            {
                path: "/marketplace/suspensions",
                element: <AdminDashboard children={<SellerSuspensions />} />,
            },
            // Analytics Routes
            {
                path: "/analytics",
                element: <AdminDashboard children={<AnalyticsOverview />} />,
            },
            // {
            //     path: "/analytics/offers",
            //     element: <AdminDashboard children={<AnalyticsOffers />} />,
            // },
            // {
            //     path: "/analytics/reviews",
            //     element: <AdminDashboard children={<AnalyticsReviews />} />,
            // },
            // {
            //     path: "/analytics/categories",
            //     element: <AdminDashboard children={<AnalyticsCategories />} />,
            // },
            // {
            //     path: "/analytics/top-listings",
            //     element: <AdminDashboard children={<AnalyticsTopListings />} />,
            // },
            // {
            //     path: "/analytics/system-health",
            //     element: <AdminDashboard children={<AnalyticsSystemHealth />} />,
            // },
        ]
    },
    {
        path: "/",
        element: <PublicRoute />,
        children: [
            {
                path: "/login",
                element: <AdminLogin />,
                index: true
            },
        ],

    }
])
